import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=c6a3dada&"
import script from "./tourist.vue?vue&type=script&lang=js&"
export * from "./tourist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports